import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import cn from 'classnames';
import { Spinner } from '../icons/spinner';

function Loader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      withBorder = _ref.withBorder,
      counter = _ref.counter;
  var showCounter = typeof counter === 'number';
  return jsx("div", {
    className: cn('zenit', className),
    sx: _objectSpread({
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: 1,
      lineHeight: 1,
      color: 'grey.10'
    }, withBorder && {
      backgroundColor: 'grey.0',
      padding: 5,
      boxShadow: 'elevation.middle',
      borderRadius: '42px'
    })
  }, jsx(Spinner, {
    sx: (showCounter || children) && {
      marginRight: 2
    }
  }), showCounter && jsx("span", {
    sx: _objectSpread({
      color: 'blue.primary'
    }, children && {
      marginRight: 2
    })
  }, counter), children);
}

Loader.defaultProps = {
  className: '',
  withBorder: false
};
export { Loader };